<template>
  <LuxLibraryFooter type="footer"></LuxLibraryFooter>
</template>

<script lang="ts" setup>
import { LuxLibraryFooter } from 'lux-design-system';
</script>
